const mapRecoverableOrder = order => {
  return {
    number: order.number,
    order_date: order.order_date,
    product_count: order.product_count,
    customer_email: order.customer_email,
  }
}

export const transformResponseRecoverableOrders = orders => {
  if (!orders) return []

  return orders.map(mapRecoverableOrder)
}
